import { render, staticRenderFns } from "./costDetail.vue?vue&type=template&id=4eb6cfda&scoped=true&"
import script from "./costDetail.vue?vue&type=script&lang=js&"
export * from "./costDetail.vue?vue&type=script&lang=js&"
import style0 from "./costDetail.vue?vue&type=style&index=0&id=4eb6cfda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb6cfda",
  null
  
)

export default component.exports